<template>
    <b-input-group>
        <input
            ref="autocomplete"
            class="form-control"
            :placeholder="placeholder"
            onfocus="value = ''"
            type="search"
            @focus="addressBoxFocused"
        >
    </b-input-group>
</template>

<script>
    /**
     * @group Inputs
     * Google-powered address auto-complete input.
     */
    export default {
        name: 'AddressAutocomplete',
        props: {
            /**
             * The target type.
             */
            targetType: {
                type: Array,
                required: false,
                // `['address']`
                default: () => ['address']
            },
            /**
             * The options for the Google address auto-complete.
             */
            options: {
                type: Object,
                required: false,
                // `{country: ['US']}`
                default: () => {
                    return {country: ['US']};
                }
            },
            /**
             * The placeholder for the search input.
             */
            placeholder: {
                type: String,
                required: false,
                // `'Search''`
                default: 'Search',
            },
        },
        data() {
            return {
                selectedAddress: null,
            };
        },
        mounted() {
            if (!window.googlePlacesIncluded) {
                let googlePlacesScript = document.createElement('script');
                googlePlacesScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCvkiAHUcLFoDl7-GIq-vOkYOEMSI4c2Es&libraries=places');
                document.head.appendChild(googlePlacesScript);
                window.googlePlacesIncluded = true;
            }
        },
        methods: {
            addressBoxFocused() {
                if (!this.autocomplete) {
                    // google is defined in the header script
                    // eslint-disable-next-line no-undef
                    this.autocomplete = new google.maps.places.Autocomplete(
                        (this.$refs.autocomplete),
                        {types: this.targetType, componentRestrictions: this.options}
                    );

                    this.autocomplete.addListener('place_changed', () => {
                        let place = this.autocomplete.getPlace();
                        this.selectedAddress = {
                            'formattedAddress': place.formatted_address,
                            'addressComponents': place.address_components
                        };

                        this.$emit('address-changed', this.selectedAddress);
                    });
                }
            }
        }
    };
</script>

<style lang="sass">
    .pac-container
        border: 1px solid var(--kc-gray-300)
        border-radius: 0.3125rem
        z-index: 9999

        .pac-item
            display: flex
            align-items: center
            font-size: 0.875rem
            font-family: Arial, sans-serif
            min-height: 3rem
            padding: 0 1rem 0 1rem
            color: var(--kc-gray-400)

            + .pac-item
                border-top-color: var(--kc-gray-300)

            .pac-item-query
                color: var(--kc-blue-800)
                font-size: 1rem
                font-family: Arial, sans-serif
                font-weight: lighter
                margin-right: 0.5rem

    body.mode.dark
        .pac-container,
        .pac-item
            background: var(--kc-blue-800)
            color: var(--kc-blue-400)

        .pac-item
            border-color: var(--kc-blue-800)

            &:hover
                background: var(--kc-blue-600)
                cursor: pointer

            + .pac-item
                border-top-color: var(--kc-blue-700)

        .pac-item-query,
        .pac-icon
            color: var(--kc-blue-300)

        .pac-matched
            color: var(--kc-blue-200)
</style>
